module.exports = __webpack_public_path__ + "img/logo.74b6ea43.png";